import React from 'react';

import { Helmet } from 'react-helmet';

import { Container } from '@mui/material';

import GHAPriceReports from './GHAPriceReports';

function GHAPriceCompetitivenessContainer() {
  return (
    <Container maxWidth={false}>
      <Helmet>
        <title>GHA Pricing Data</title>
      </Helmet>
      <GHAPriceReports />
    </Container>
  );
}

export default GHAPriceCompetitivenessContainer;
